import { FullComment } from 'model';

/**
 * Take an array of comments which have children and returns a flat single array of all
 * of the comments in the tree. This still preserves refererences to the children
 *
 * @param { FullComment[] } comments An array of comments
 * @returns {FullComment[]} The flattened array of comments
 */
export const flattenTree = (comments: FullComment[]): FullComment[] => {
	const result: FullComment[] = [];
	comments.forEach(comment => {
		result.push(comment);
		if (comment.children && comment.children.length > 0) {
			result.push(...flattenTree(comment.fullChildren));
		}
	});
	return result;
};
